declare namespace $ {

	export class $mol_icon_backspace extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=backspace.view.tree.d.ts.map